<template>
    <div class="bg-gray grid-content div-footer">
        <el-row>
            <p>监督机构:  <a href="http://www.nmpa.gov.cn">国家药品监督管理局</a>&nbsp;
            <a href="http://www.jsfda.gov.cn">江苏省药品监督管理局</a>&nbsp;
            <a href="http://amr.nanjing.gov.cn/">南京市市场监督管理局</a></p>
        </el-row>
        <el-row>
            <a href="http://beian.miit.gov.cn">备案号：苏ICP备2022028613号</a>&nbsp;
            <a href="javascript:;">药品经营许可证号:苏AA0250536</a>
            <a href="javascript:;">药品、医疗器械互联网信息服务资格备案:苏网药信备字〔2025〕00065号</a>
        </el-row>
        <el-row>
            <p>版权所有 &nbsp;©南京永安医药有限公司 </p>
        </el-row>
    </div>
</template>
<script>
export default {
    name : 'Footer'
}
</script>
<style>
    .div-footer{
        background-color:  rgba(255, 255, 255, 0.9);
        padding:8px;
    }
    .topLogoImage{
        width: 100%;
    }
    .topLink{
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue